import { DirectUpload } from '@rails/activestorage';

window.App = {
  createImageUploader: (container) => {
    const uploadImgEl = container.querySelector('.image-uploader');
    const fileEl = container.querySelector('input[type=file]');
    const uploadUrl = fileEl.dataset.directUploadUrl;

    uploadImgEl.addEventListener('click', (e) => {
      fileEl.click();
    });

    fileEl.addEventListener('change', (event) => {
      Array.from(fileEl.files).forEach(file => uploadFile(file));
      fileEl.value = null;
    });


    const createImageBox = () => {
      const curImgEle = window.preview.getCurImage();
      if (curImgEle) {
        // 关闭预览
        window.preview.close();
        const oldId = curImgEle.getAttribute('data-id');
        const oldInput = $(`input[data-id=${oldId}]`);
        const imageBox = curImgEle.parentElement
        imageBox.classList.add('loading')
        // changeimg
        imageBox.innerHTML = ''
        // change input
        if (oldInput) {
          oldInput.remove()
        } 
        return imageBox
      } else {
        const imageBox = document.createElement('div');
        const imageWrap = document.querySelector('.image-uploader-container');
        imageBox.className = 'image-item loading';
        imageWrap.insertBefore(imageBox, uploadImgEl);
        return imageBox;
      }
    }
    
    const updateFile = (id, filename, imageBox) => {
      const src = imageBox.getAttribute('data-src');
      imageBox.classList.remove('loading')
      imageBox.innerHTML = `<span class="iconfont icon-close btn-del"></span>
      <img data-id=${id} data-preview src="${src}"/>`
      addHiddenEl(id);
    };
    
    // 添加隐藏的表单域
    const addHiddenEl = (id) => {
      const hiddenEl = document.createElement('input');
      hiddenEl.setAttribute('type', 'hidden');
      hiddenEl.setAttribute('value', id);
      hiddenEl.setAttribute('data-id', id);
      hiddenEl.name = fileEl.name;
      container.appendChild(hiddenEl);
    };

    const uploadFile = (file) => {
      const imageBox = createImageBox()
      const upload = new DirectUpload(file, uploadUrl);
      const reader = new FileReader();

      reader.readAsDataURL(file);

      reader.onload = function() {
        imageBox.setAttribute('data-src', reader.result)
      }

      upload.create((error, blob) => {
        if (!error) {
          const { signed_id: id, filename } = blob;
          updateFile(id, filename, imageBox);
        } else {
          imageBox.remove();
        }
      });
    };
  },
};
